'use client';
import React from 'react';
import Link from 'next/link';
import { Phone, MessageCircle, Shield, FileText, HelpCircle } from 'lucide-react';

export default function SiteFooter() {
  const whatsappUrl = 'https://wa.me/254118333000?text=Hello%20MKUBWA%20Support';
  const callUrl = 'tel:+254118333000';

  return (
    <footer className="w-full mt-auto" style={{ background: 'var(--secondary)', borderTop: '1px solid var(--border)' }}>
      <div className="max-w-5xl mx-auto px-4 py-6">
        {/* Top row */}
        <div className="flex flex-wrap items-center justify-between gap-4 mb-4">
          <div className="flex items-center gap-2">
            <img src="/assets/china-ndogo-logo.svg" alt="China Ndogo Logo" width={28} height={28} className="rounded-lg" />
            <div>
              <span className="text-sm font-extrabold tracking-tight text-gradient-green">CHINA NDOGO</span>
              <span className="text-[9px] font-bold tracking-widest ml-2" style={{ color: '#FFB300' }}>MKUBWA WAO</span>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <a href={callUrl}
              className="flex items-center gap-1.5 px-3 py-1.5 rounded-xl text-xs font-semibold transition-all hover:opacity-80"
              style={{ background: 'rgba(0,200,83,0.1)', border: '1px solid rgba(0,200,83,0.2)', color: 'var(--primary)' }}>
              <Phone size={13} />
              +254 118 333 000
            </a>
            <a href={whatsappUrl} target="_blank" rel="noopener noreferrer"
              className="flex items-center gap-1.5 px-3 py-1.5 rounded-xl text-xs font-semibold transition-all hover:opacity-80"
              style={{ background: 'rgba(37,211,102,0.1)', border: '1px solid rgba(37,211,102,0.2)', color: '#25D366' }}>
              <MessageCircle size={13} />
              WhatsApp
            </a>
          </div>
        </div>

        {/* Links row */}
        <div className="flex flex-wrap items-center gap-x-5 gap-y-2 mb-4">
          <Link href="/terms" className="text-xs transition-colors hover:opacity-80 flex items-center gap-1"
            style={{ color: 'var(--muted-foreground)' }}>
            <FileText size={11} /> Terms of Service
          </Link>
          <Link href="/privacy" className="text-xs transition-colors hover:opacity-80 flex items-center gap-1"
            style={{ color: 'var(--muted-foreground)' }}>
            <Shield size={11} /> Privacy Policy
          </Link>
          <Link href="/chat-screen" className="text-xs transition-colors hover:opacity-80 flex items-center gap-1"
            style={{ color: 'var(--muted-foreground)' }}>
            <MessageCircle size={11} /> Live Chat
          </Link>
          <Link href="/help" className="text-xs transition-colors hover:opacity-80 flex items-center gap-1"
            style={{ color: 'var(--muted-foreground)' }}>
            <HelpCircle size={11} /> Help Centre
          </Link>
        </div>

        {/* Bottom row */}
        <div className="flex flex-wrap items-center justify-between gap-2 pt-3" style={{ borderTop: '1px solid var(--border)' }}>
          <p className="text-xs" style={{ color: 'var(--muted-foreground)' }}>
            © {new Date()?.getFullYear()} <strong style={{ color: 'var(--foreground)' }}>Staff Me Out Limited</strong>. All rights reserved.
          </p>
          <p className="text-xs" style={{ color: 'var(--muted-foreground)' }}>
            By using MKUBWA you agree to our{' '}
            <Link href="/terms" className="underline hover:opacity-80" style={{ color: 'var(--primary)' }}>Terms</Link>
            {' '}&amp;{' '}
            <Link href="/privacy" className="underline hover:opacity-80" style={{ color: 'var(--primary)' }}>Privacy Policy</Link>
          </p>
        </div>
      </div>
    </footer>
  );
}
